import { EnvVariables } from 'src/types/model';

export const getEnvVariables = (): EnvVariables => {
  return {
    resizeImages: process.env.RESIZE_IMAGES || '',
  };
};
